import { render, staticRenderFns } from "./AddContentPage.vue?vue&type=template&id=7addd7d4&scoped=true"
import script from "./AddContentPage.vue?vue&type=script&lang=js"
export * from "./AddContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7addd7d4",
  null
  
)

export default component.exports